import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assets/pathfinder-logo.png";
import { LogoHeader } from "../components/header";
import Button from "../components/button";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchInit,
  verifyCaptcha,
  resetState,
  toggleQuestionPopup,
} from "../slices/dataSlice";
import Loader from "../components/loader";
import { clearState } from "../store/localStorage";
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';


function Home() {
  const { initAPI } = useSelector((state) => state.data);

  const [hasSession, setHasSession] = useState(false);
  const [captchaError, setCaptchaError] = useState(null);

  const { executeRecaptcha } = useGoogleReCaptcha();

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const getSessionPayload = () => {
    try {
      const saved = localStorage.getItem("data_store");
      if (!saved) return false;

      const parsed = JSON.parse(saved);

      return {
        guid: parsed.guid,
        sessionId: parsed.sessionId,
      };
    } catch {
      return null;
    }
  };

  useEffect(() => {
    setHasSession(getSessionPayload());
  }, []);

  const handleGoogleCaptcha = async () => {
    if (!executeRecaptcha) {
      console.log('Execute recaptcha not yet available');
      return;
    }

    const token = await executeRecaptcha('home_action');
    const {payload} = await dispatch(verifyCaptcha(token));
    if(payload?.status === 'failed'){ 
      setCaptchaError({
        title: "Access temporarily restricted.",
        message: "For security reasons, this request cannot be completed right now. Please try again in a few minutes."
      });
      return 'FAILED' 
    }

    return 'SUCCESS';
  };


  const handleStartExploring = async () => {
    const sessionPayload = getSessionPayload();

    clearState();
    dispatch(resetState());

    const d = await handleGoogleCaptcha();
    if(d !== 'FAILED'){
        const data = await dispatch(fetchInit(sessionPayload));
        // fetchInit rejected (toast already shown by interceptor) — bail out
        if (data.payload?.httpStatus) return;
        if (data.payload?.moreQuestions) {
          dispatch(toggleQuestionPopup(true));
          navigate("/careers");
        }
    }
    
    
  };

  const handleContinue = async () => {
    navigate("/careers");
  };

  return (
    <div className="min-h-screen flex flex-col">
      <LogoHeader />
      <div className="flex-1 flex flex-col items-center justify-center text-center p-10 sm:p-5 ">
        <div className="relative">
          <h1 className="text-3xl text-border-extrabold font-semibold absolute -top-10 left-0">
            Welcome to
          </h1>
          <img
            src={logo}
            alt="Pathfinder: Find careers that match your interests"
            className="lg:h-32 w-auto mb-10 sm:h-auto md:h-auto"
          />
        </div>
        <p className="text-black max-w-3xl mb-12 lg:text-xl sm:text-sm md:text-lg">
          Find out how what you're interested in can translate into a future
          career! With NYCPS Pathfinder we talk with you about your interests
          and hobbies, then show how those connect to career choices. Not a
          quiz, not a survey, but a real chance to explore how to turn your
          passion into a living.
        </p>


        {captchaError && (
          <div
            className="mb-4 p-4 bg-error-subtle border border-error text-error-emphasis rounded"
            role="alert"
          >
            <strong>{captchaError.title}</strong>
            <br />
            {captchaError.message}
          </div>
        )}

        {initAPI.status === "loading" ? (
          <Loader />
        ) : !hasSession ? ( captchaError ? null : 
          <Button
            className="w-full text-xs sm:text-sm md:text-base lg:text-lg font-semibold py-5"
            onClick={handleStartExploring}
          >
            Start Exploring
          </Button>
        ) : ( captchaError ? null :
          <div className="flex w-full justify-center gap-5">
            <Button
              className="w-full text-xs sm:text-sm md:text-base lg:text-lg font-semibold py-5"
              onClick={handleContinue}
            >
              Continue Prior Session
            </Button>
            <Button
              className="w-full text-xs sm:text-sm md:text-base lg:text-lg font-semibold py-5"
              color="nycgreen"
              onClick={handleStartExploring}
            >
              Start at the Beginning
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}

export default Home;
